
  <div>
    <!-- Create Button Always Visible -->
    <div class="mb-3">
      <button
        class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark p-1 d-none"
        data-bs-toggle="modal"
        data-bs-target="#assign_subentity_modal"
        @click="open_create_subentity_modal">
        Assign Sub-Entities
      </button>
    </div>

    <!-- Table or Empty State -->
    <div v-if="table_safe_entity_list.length === 0" class="text-center py-5">
      <p class="text-muted mb-4">No sub-entities available yet</p>
    </div>

    <div v-else class="card shadow-sm border table-border-color rounded-lg p-3 table-responsive">
      <table class="table table-hover" id="subentity_by_id_table">
        <thead class="custom-header">
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Sub-Entity Name</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(entity, index) in table_safe_entity_list" :key="entity.id">
            <td class="text-xxs text-start">{{ index + 1 }}</td>
            <td class="text-xxs text-start">{{ entity.name }}</td>
            <td class="text-xxs text-start">{{ entity.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>


<teleport to="body">
<div class="modal fade" id="assign_subentity_modal" tabindex="-1" aria-labelledby="assign_subentity_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="assign_subentity_label">Assign Sub-Entities</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-hover" id="assign_subentity_table">
            <thead class="custom-header">
              <tr>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">NO</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Sub-Entity Name</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Select</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(entity, index) in table_safe_form_list" :key="entity.id">
                <td class="text-xxs text-start">{{ index + 1 }}</td>
                <td class="text-xxs text-start">{{ entity.name }}</td>
                <td class="text-xxs text-start">{{ entity.description }}</td>
                <td class="ps-3">
                    <div class="modal-form-check form-check form-switch mb-0 text-xxs">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'type-' + index"
                        v-model="entity.selected"
                    >
                    </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm px-3 text-xxs shadow"
          @click="assign_selected_subentities">
          Assign Selected
        </button>
      </div>
    </div>
  </div>
</div>
</teleport>